var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6266 8.42036V12.0174C16.6266 14.5352 15.184 15.6143 13.0202 15.6143H5.80752C3.64371 15.6143 2.20117 14.5352 2.20117 12.0174V6.98157C2.20117 4.46368 3.64371 3.38458 5.80752 3.38458H10.8564",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80664 7.34125L8.06422 9.13974C8.80713 9.72965 10.0261 9.72965 10.769 9.13974L11.6201 8.46351",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8227 6.62189C15.8186 6.62189 16.6259 5.81668 16.6259 4.8234C16.6259 3.83012 15.8186 3.0249 14.8227 3.0249C13.8268 3.0249 13.0195 3.83012 13.0195 4.8234C13.0195 5.81668 13.8268 6.62189 14.8227 6.62189Z",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms-notification.1f62bd424fc56f57ce514eaf7eb64645.svg";
export { ForwardRef as ReactComponent };